var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-7"},[_c('div',{staticClass:"list-header py-3 mt-1"}),_c('v-row',{staticClass:"mb-4"},[_c('v-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"form-stepper-header"},[_c('div',{staticClass:"form-stepper-header-item",class:{
          active: _vm.form === 1,
        }},[_c('span',{staticClass:"value"},[_vm._v("1")]),_c('span',{staticClass:"label"},[_vm._v("Data Utama")])]),_c('div',{staticClass:"form-stepper-header-splitter"},[_c('span')]),_c('div',{staticClass:"form-stepper-header-item",class:{
          active: _vm.form === 2,
        }},[_c('span',{staticClass:"value"},[_vm._v("2")]),_c('span',{staticClass:"label"},[_vm._v("Data Bibit")])]),_c('div',{staticClass:"form-stepper-header-splitter"},[_c('span')]),_c('div',{staticClass:"form-stepper-header-item",class:{
          active: _vm.form === 3,
        }},[_c('span',{staticClass:"value"},[_vm._v("3")]),_c('span',{staticClass:"label"},[_vm._v("Koordinat & Periode")])]),_c('div',{staticClass:"form-stepper-header-splitter"},[_c('span')]),_c('div',{staticClass:"form-stepper-header-item",class:{
          active: _vm.form === 4,
        }},[_c('span',{staticClass:"value"},[_vm._v("4")]),_c('span',{staticClass:"label"},[_vm._v("Foto & Dokumentasi")])])])])],1),_c('ValidationObserver',{directives:[{name:"show",rawName:"v-show",value:(_vm.form === 1),expression:"form === 1"}],ref:"firstForm",staticClass:"geko-form-wrapper",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_c('v-row',[_c('div',{staticClass:"list-header py-3 mt-1"},[_c('div',{staticClass:"pr-5 mr-5 d-flex flex-row",staticStyle:{"justify-content":"space-between"}},[_c('h4',[_vm._v("Data Umum")])]),_c('div',{staticClass:"d-flex flex-row geko-list-header-action"},[_c('div',{staticClass:"geko-list-header-toolbar"})])]),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Tahun Program',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'program_year',
            option: {
              default_options: _vm.$_config.programYear.options.map(
                (x) => {
                  return {
                    label: x,
                    code: x,
                  }
                }
              ),
              list_pointer: {
                label: 'label',
                code: 'code',
                display: ['label'],
              },
            },
          }},model:{value:(_vm.formData.program_year),callback:function ($$v) {_vm.$set(_vm.formData, "program_year", $$v)},expression:"formData.program_year"}})],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'MoU No',
            validation: ['required'],
            col_size: 6,
            type: 'text',
          }},model:{value:(_vm.formData.mou_no),callback:function ($$v) {_vm.$set(_vm.formData, "mou_no", $$v)},expression:"formData.mou_no"}})],1)],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'PIC T4T',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 't4t_employees',
            param: {
              page: 1,
              per_page: 10,
            },
            api: 'employees/all/options',
            default_label: _vm.formData.t4t_employees,
            option: {
              getterKey: 'data',
              list_pointer: {
                code: 'nik',
                label: 'name',
                display: ['name', 'nik'],
              },
            },
          }},model:{value:(_vm.formData.t4t_employees),callback:function ($$v) {_vm.$set(_vm.formData, "t4t_employees", $$v)},expression:"formData.t4t_employees"}})],1)],1),_c('div',{staticClass:"list-header py-3 mt-1"},[_c('div',{staticClass:"pr-5 mr-5 d-flex flex-row",staticStyle:{"justify-content":"space-between"}},[_c('h4',[_vm._v("Data Lahan Umum")])]),_c('div',{staticClass:"d-flex flex-row geko-list-header-action"},[_c('div',{staticClass:"geko-list-header-toolbar"})])]),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Luas Area Lahan (Dalam Meter)',
            validation: ['required'],
            col_size: 6,
            type: 'number',
          }},model:{value:(_vm.formData.land_area),callback:function ($$v) {_vm.$set(_vm.formData, "land_area", $$v)},expression:"formData.land_area"}})],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Cakupan Lahan',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'land_coverage',
            option: {
              list_pointer: {
                label: 'label',
                code: 'code',
                display: ['label'],
              },
              default_options: [
                {
                  label: '0%',
                  code: '0',
                },
                {
                  label: '25%',
                  code: '25',
                },
                {
                  label: '50%',
                  code: '50',
                },
                {
                  label: '75%',
                  code: '75',
                },
                {
                  label: '100%',
                  code: '100',
                }
              ],
            },
          }},model:{value:(_vm.formData.land_coverage),callback:function ($$v) {_vm.$set(_vm.formData, "land_coverage", $$v)},expression:"formData.land_coverage"}})],1),_c('v-col',[_c('geko-input',{attrs:{"disabled":true,"item":{
            label: 'Luas Area Tanam (Dalam Meter)',
            validation: ['required'],
            col_size: 6,
            type: 'number',
          }},model:{value:(_vm.formData.planting_area),callback:function ($$v) {_vm.$set(_vm.formData, "planting_area", $$v)},expression:"formData.planting_area"}})],1)],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Pola Tanam',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'opsi_pola_tanam',
            option: {
              list_pointer: {
                label: 'label',
                code: 'code',
                display: ['label'],
              },
              default_options: [
                {
                  label: 'Pola Agroforestry Acak',
                  code: 'Pola Agroforestry Acak',
                },
                {
                  label: 'Pola Agroforestry Lajur',
                  code: 'Pola Agroforestry Lajur',
                },
                {
                  label: 'Pola Agroforestry Tepi',
                  code: 'Pola Agroforestry Tepi',
                },
                {
                  label: 'Pola Konservasi Pohon Kayu',
                  code: 'Pola Konservasi Pohon Kayu',
                },
                {
                  label: 'Pola Konservasi Pohon Kayu + MPTS',
                  code: 'Pola Konservasi Pohon Kayu + MPTS',
                }
              ],
            },
          }},model:{value:(_vm.formData.opsi_pola_tanam),callback:function ($$v) {_vm.$set(_vm.formData, "opsi_pola_tanam", $$v)},expression:"formData.opsi_pola_tanam"}})],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Status Lahan',
            validation: ['required'],
            col_size: 6,
            type: 'text',
          }},model:{value:(_vm.formData.status),callback:function ($$v) {_vm.$set(_vm.formData, "status", $$v)},expression:"formData.status"}})],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Jarak Lahan Dari Rumah (Dalam Meter)',
            validation: ['required'],
            col_size: 6,
            type: 'number',
          }},model:{value:(_vm.formData.land_distance),callback:function ($$v) {_vm.$set(_vm.formData, "land_distance", $$v)},expression:"formData.land_distance"}},[_c('v-btn',{staticClass:"text-lowercase",attrs:{"slot":"append","text":"","rounded":""},slot:"append"},[_vm._v(" m"),_c('sup',[_vm._v("2")])])],1)],1)],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Akses Lahan',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'land_access',
            option: {
              list_pointer: {
                label: 'label',
                code: 'code',
                display: ['label'],
              },
              default_options: [
                {
                  label: 'Jalan Kaki',
                  code: 'Jalan Kaki',
                },
                {
                  label: 'Motor',
                  code: 'Motor',
                },
                {
                  label: 'Mobil',
                  code: 'Mobil',
                },
              ],
            },
          }},model:{value:(_vm.formData.land_access),callback:function ($$v) {_vm.$set(_vm.formData, "land_access", $$v)},expression:"formData.land_access"}})],1)],1),_c('div',{staticClass:"list-header py-3 mt-1"},[_c('div',{staticClass:"pr-5 mr-5 d-flex flex-row",staticStyle:{"justify-content":"space-between"}},[_c('h4',[_vm._v("Data Lokasi")])]),_c('div',{staticClass:"d-flex flex-row geko-list-header-action"},[_c('div',{staticClass:"geko-list-header-toolbar"})])]),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year,"item":{
            label: 'Management Unit',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'mu_no',
            param: {
              page: 1,
              per_page: 10,
            },
            api: 'new-utilities/management-units',
            default_label: _vm.formData.mu_no,
            option: {
              getterKey: 'data',
              list_pointer: {
                code: 'mu_no',
                label: 'name',
                display: ['name', 'mu_no'],
              },
            },
          }},model:{value:(_vm.formData.mu_no),callback:function ($$v) {_vm.$set(_vm.formData, "mu_no", $$v)},expression:"formData.mu_no"}})],1),_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year,"item":{
            label: 'Provinsi',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'province',
            param: {
              page: 1,
              per_page: 10,
            },
            api: 'new-utilities/provinces',
            default_label: _vm.formData.province,
            option: {
              getterKey: 'data',
              list_pointer: {
                code: 'province_code',
                label: 'name',
                display: ['name', 'province_code'],
              },
            },
          }},model:{value:(_vm.formData.province),callback:function ($$v) {_vm.$set(_vm.formData, "province", $$v)},expression:"formData.province"}})],1)],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year || !_vm.formData.province,"item":{
            label: 'Kabupaten',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'kabupaten',
            param: {
              page: 1,
              per_page: 10,
              province_code: _vm.formData.province
            },
            api: 'new-utilities/kabupatens',
            default_label: _vm.formData.kabupaten,
            option: {
              getterKey: 'data',
              list_pointer: {
                code: 'kabupaten_no',
                label: 'name',
                display: ['name', 'kabupaten_no'],
              },
            },
          }},model:{value:(_vm.formData.kabupaten),callback:function ($$v) {_vm.$set(_vm.formData, "kabupaten", $$v)},expression:"formData.kabupaten"}})],1),_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year || !_vm.formData.province || !_vm.formData.kabupaten,"item":{
              label: 'Kecamatan',
              validation: ['required'],
              col_size: 6,
              type: 'select',
              setter: 'kecamatan',
              param: {
                page: 1,
                per_page: 10,
                kode_kabupaten: _vm.formData.kabupaten
              },
              api: 'new-utilities/kecamatans',
              default_label: _vm.formData.kecamatan,
              option: {
                getterKey: 'data',
                list_pointer: {
                  code: 'kode_kecamatan',
                  label: 'name',
                  display: ['name', 'kode_kecamatan'],
                },
              },
            }},model:{value:(_vm.formData.kecamatan),callback:function ($$v) {_vm.$set(_vm.formData, "kecamatan", $$v)},expression:"formData.kecamatan"}})],1)],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year || !_vm.formData.mu_no || !_vm.formData.province || !_vm.formData.kabupaten || !_vm.formData.kecamatan,"item":{
              label: 'Status Desa',
              validation: ['required'],
              col_size: 6,
              type: 'select',
              setter: 'village',
              option: {
                list_pointer: {
                  label: 'label',
                  code: 'code',
                  display: ['label'],
                },
                default_options: [
                  {
                    label: 'Semua Desa',
                    code: 'all',
                  },
                  {
                    label: 'Desa Program',
                    code: 'desa program',
                  },
                  {
                    label: 'Desa Diluar Program',
                    code: 'desa diluar program',
                  },
                ],
              }
            }},model:{value:(_vm.statusDesa),callback:function ($$v) {_vm.statusDesa=$$v},expression:"statusDesa"}})],1),_c('v-col',[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year || !_vm.formData.mu_no || !_vm.formData.province || !_vm.formData.kabupaten || !_vm.formData.kecamatan,"item":{
              label: 'Desa',
              validation: ['required'],
              col_size: 6,
              type: 'select',
              setter: 'village',
              param: {
                page: 1,
                per_page: 10,
                kode_kecamatan: _vm.formData.kecamatan
              },
              api: 'new-utilities/desas/option',
              default_label: _vm.formData.village,
              option: {
                getterKey: 'data',
                filterBy: {
                  key: 'statusDesa',
                  value: _vm.statusDesa
                },
                list_pointer: {
                  code: 'kode_desa',
                  label: 'name',
                  display: ['name', 'kode_desa', 'statusDesa'],
                },
              },
            }},model:{value:(_vm.formData.village),callback:function ($$v) {_vm.$set(_vm.formData, "village", $$v)},expression:"formData.village"}})],1)],1),_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Alamat',
            validation: ['required'],
            col_size: 6,
            type: 'text',
            setter: 'address',
          }},model:{value:(_vm.formData.address),callback:function ($$v) {_vm.$set(_vm.formData, "address", $$v)},expression:"formData.address"}})],1),_c('v-col')],1),_c('div',{staticClass:"list-header py-3 mt-1"},[_c('div',{staticClass:"pr-5 mr-5 d-flex flex-row",staticStyle:{"justify-content":"space-between"}},[_c('h4',[_vm._v("Data PIC Lahan Umum")])]),_c('div',{staticClass:"d-flex flex-row geko-list-header-action"},[_c('div',{staticClass:"geko-list-header-toolbar"}),_vm._v(" Data 1 Adalah PIC Lahan Utama ")])]),_c('v-row',[_c('v-col',[_c('div',{staticClass:"pic-person-list"},[_vm._l((_vm.formData.pic_list),function(person,i){return _c('v-row',{key:'persons-' + i},[_c('v-col',{staticClass:"index-wrapper"},[_c('div',{staticClass:"index"},[_vm._v(_vm._s(i + 1))])]),_c('v-col',{attrs:{"md":"2"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Nama',
                  validation: ['required'],
                  type: 'text',
                }},model:{value:(person.name),callback:function ($$v) {_vm.$set(person, "name", $$v)},expression:"person.name"}})],1),_c('v-col',{attrs:{"md":"3"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Nomor KTP',
                  validation: ['required'],
                  type: 'text',
                }},model:{value:(person.ktp),callback:function ($$v) {_vm.$set(person, "ktp", $$v)},expression:"person.ktp"}})],1),_c('v-col',{attrs:{"md":"2"}},[_c('geko-input',{attrs:{"item":{
                  label: 'No HP/WA',
                  validation: ['required', 'phone'],
                  type: 'text',
                }},model:{value:(person.contact),callback:function ($$v) {_vm.$set(person, "contact", $$v)},expression:"person.contact"}})],1),_c('v-col',{attrs:{"md":"3"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Project',
                  validation: ['required'],
                  col_size: 6,
                  type: 'select',
                  api: 'GetProjectAllAdmin',
                  param: {
                  },
                  setter: 'project_no',
                  option: {
                    getterKey: 'data',
                    list_pointer: {
                      label: 'project_name',
                      code: 'project_no',
                      display: ['project_name', 'project_no'],
                    },
                  },
                }},model:{value:(person.project_no),callback:function ($$v) {_vm.$set(person, "project_no", $$v)},expression:"person.project_no"}})],1),_c('v-col',{attrs:{"md":"2"}},[_c('geko-input',{attrs:{"item":{
                  label: 'Tujuan Penanaman',
                  validation: ['required'],
                  col_size: 6,
                  type: 'select',
                  setter: 'plannting_goals',
                  option: {
                    list_pointer: {
                      label: 'label',
                      code: 'code',
                      display: ['label'],
                    },
                    default_options: [
                      {
                        label: 'Penanaman Biasa',
                        code: 'planting',
                      },
                      {
                        label: 'Penanaman Ulang',
                        code: 're-planting',
                      },
                      {
                        label: 'Optimalisasi',
                        code: 'optimalization',
                      },
                    ],
                  },
                }},model:{value:(person.plannting_goals),callback:function ($$v) {_vm.$set(person, "plannting_goals", $$v)},expression:"person.plannting_goals"}})],1),_c('v-col',{staticClass:"d-flex flex-column justify-content-center",staticStyle:{"justify-content":"center","align-items":"flex-start"},attrs:{"md":"1"}},[(_vm.isCreate)?_c('button',{on:{"click":function($event){return _vm.removeLahanUmumPIC(i)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("mdi-close")])],1):_vm._e()])],1)}),(_vm.isCreate)?_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('v-btn',{attrs:{"variant":"primary"},on:{"click":_vm.addLahanUmumPIC}},[_c('v-icon',[_vm._v("mdi-plus")]),_c('span',[_vm._v("Tambah PIC Lahan Umum")])],1)],1)],1):_vm._e()],2)])],1),_c('v-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"d-flex flex-row justify-content-end",staticStyle:{"justify-content":"flex-end"}},[_c('v-btn',{staticClass:"mr-3",attrs:{"variant":"light"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Batal")]),_c('v-btn',{attrs:{"type":"submit","variant":"success","disabled":_vm.loading}},[_c('v-icon',[_vm._v("mdi-chevron-right")]),_c('span',[_vm._v("Selanjutnya")])],1)],1)])],1)]}}])}),_c('ValidationObserver',{directives:[{name:"show",rawName:"v-show",value:(_vm.form === 2),expression:"form === 2"}],ref:"secondForm",staticClass:"geko-form-wrapper",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[(_vm.isCreate)?_c('v-row',[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Tambah Detail Bibit Per PIC")])])],1):_vm._e(),(_vm.isCreate)?_c('v-row',[_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Tipe Bibit',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'tree_category',
            option: {
              list_pointer: {
                label: 'label',
                code: 'code',
                display: ['label'],
              },
              default_options: [
                {
                  label: 'KAYU',
                  code: 'Pohon_Kayu',
                },
                {
                  label: 'MPTS',
                  code: 'Pohon_Buah',
                },
                {
                  label: 'CROPS',
                  code: 'Tanaman_Bawah_Empon',
                },
                {
                  label: 'MANGROVE',
                  code: 'Mangrove',
                },
              ],
            },
          }},model:{value:(_vm.tempInsertSeed.tree_category),callback:function ($$v) {_vm.$set(_vm.tempInsertSeed, "tree_category", $$v)},expression:"tempInsertSeed.tree_category"}})],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Nama Pohon Bibit',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'tree_seed',
            param: {
              limit: 10,
              offset: 0,
              tree_category: _vm.tempInsertSeed.tree_category
            },
            api: 'GetTreesAll_new',
            default_label: _vm.tempInsertSeed.tree_code,
            option: {
              getterKey: 'result',
              list_pointer: {
                code: 'tree_code',
                label: 'tree_name',
                display: ['tree_name', 'tree_code'],
              },
            },
          }},model:{value:(_vm.tempInsertSeed.tree_code),callback:function ($$v) {_vm.$set(_vm.tempInsertSeed, "tree_code", $$v)},expression:"tempInsertSeed.tree_code"}})],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Jumlah Bibit',
            validation: ['required'],
            col_size: 6,
            type: 'number',
          }},model:{value:(_vm.tempInsertSeed.seed_amount),callback:function ($$v) {_vm.$set(_vm.tempInsertSeed, "seed_amount", $$v)},expression:"tempInsertSeed.seed_amount"}})],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'PIC Bibit',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'seed_PIC',
            option: {
              list_pointer: {
                label: 'name',
                code: 'pic_no',
                display: ['name', 'pic_no'],
              },
              default_options: _vm.formData.pic_list
            },
          }},model:{value:(_vm.tempInsertSeed.seed_PIC),callback:function ($$v) {_vm.$set(_vm.tempInsertSeed, "seed_PIC", $$v)},expression:"tempInsertSeed.seed_PIC"}})],1),_c('v-col',[_c('v-btn',{staticClass:"ma-2",attrs:{"outlined":"","fab":"","color":"success"},on:{"click":() => _vm.addBibitPerPIC()}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)],1):_vm._e(),_c('v-row',[_c('div',{staticClass:"list-header py-3 mt-1"},[_c('div',{staticClass:"pr-5 mr-5 d-flex flex-row",staticStyle:{"justify-content":"space-between"}},[_c('h4',[_vm._v("Tabel Bibit Tertambah")])]),_c('div',{staticClass:"d-flex flex-row geko-list-header-action"},[_c('div',{staticClass:"geko-list-header-toolbar"})])]),_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12"}},[_c('v-data-table',{staticClass:"elevation-3",attrs:{"headers":_vm.seedTable.header,"items":_vm.formData.detailSeed,"append-icon":"mdi-magnify","items-per-page":10},scopedSlots:_vm._u([{key:"item.no",fn:function({ index }){return [_vm._v(" "+_vm._s(++index)+" ")]}},(_vm.isCreate)?{key:"item.actions",fn:function({ item }){return [_c('v-icon',{staticClass:"mr-2",attrs:{"color":"red"},on:{"click":function($event){return _vm.removeBibitPerPIC(item)}}},[_vm._v(" mdi-delete ")])]}}:null],null,true)})],1)],1),_c('v-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"d-flex flex-row justify-content-end",staticStyle:{"justify-content":"flex-end"}},[_c('v-btn',{staticClass:"mr-3",attrs:{"variant":"light"},on:{"click":function($event){_vm.form--}}},[_vm._v("Kembali")]),_c('v-btn',{attrs:{"type":"submit","variant":"success","disabled":_vm.loading}},[_c('v-icon',[_vm._v("mdi-chevron-right")]),_c('span',[_vm._v("Selanjutnya")])],1)],1)])],1)]}}])}),_c('ValidationObserver',{directives:[{name:"show",rawName:"v-show",value:(_vm.form === 3),expression:"form === 3"}],ref:"thirdForm",staticClass:"geko-form-wrapper",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_c('v-row',[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Koordinat & Periode")])])],1),_c('v-row',[_c('div',{staticClass:"list-header py-3 mt-1"},[_c('div',{staticClass:"pr-5 mr-5 d-flex flex-row",staticStyle:{"justify-content":"space-between"}},[_c('h4',[_vm._v("Data Koordinat")])]),_c('div',{staticClass:"d-flex flex-row geko-list-header-action"},[_c('div',{staticClass:"geko-list-header-toolbar"})])]),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Longitude',
            validation: ['required'],
            col_size: 6,
            type: 'text',
          }},model:{value:(_vm.formData.longitude),callback:function ($$v) {_vm.$set(_vm.formData, "longitude", $$v)},expression:"formData.longitude"}})],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Latitude',
            validation: ['required'],
            col_size: 6,
            type: 'text',
          }},model:{value:(_vm.formData.latitude),callback:function ($$v) {_vm.$set(_vm.formData, "latitude", $$v)},expression:"formData.latitude"}})],1)],1),_c('v-row',[_c('div',{staticClass:"list-header py-3 mt-1"},[_c('div',{staticClass:"pr-5 mr-5 d-flex flex-row",staticStyle:{"justify-content":"space-between"}},[_c('h4',[_vm._v("Data Periode")])]),_c('div',{staticClass:"d-flex flex-row geko-list-header-action"},[_c('div',{staticClass:"geko-list-header-toolbar"})])]),_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","lg":"4"}},[_c('p',{staticClass:"mb-0"},[_c('strong',[_vm._v("Tanggal Penilikan Lubang Tanam")])]),_c('v-btn',{attrs:{"rounded":"","color":"green white--text","disabled":""}},[_vm._v(" "+_vm._s(_vm.dateFormat(_vm.formData.surviellance_hole_date, "DD MMMM Y"))+" ")])],1),_c('v-col',[_c('geko-input',{attrs:{"item":{
            label: 'Tanggal Distribusi',
            validation: ['required'],
            col_size: 6,
            type: 'date',
            setter: 'date',
          }},model:{value:(_vm.formData.distribution_date),callback:function ($$v) {_vm.$set(_vm.formData, "distribution_date", $$v)},expression:"formData.distribution_date"}})],1),_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","lg":"4"}},[_c('p',{staticClass:"mb-0"},[_c('strong',[_vm._v("Tanggal Realisasi Tanam")])]),_c('v-btn',{attrs:{"rounded":"","color":"green white--text","disabled":""}},[_vm._v(" "+_vm._s(_vm.dateFormat(_vm.formData.planting_date, "DD MMMM Y"))+" ")])],1)],1),_c('v-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"d-flex flex-row justify-content-end",staticStyle:{"justify-content":"flex-end"}},[_c('v-btn',{staticClass:"mr-3",attrs:{"variant":"light"},on:{"click":function($event){_vm.form--}}},[_vm._v("Kembali")]),_c('v-btn',{attrs:{"type":"submit","variant":"success","disabled":_vm.loading}},[_c('v-icon',[_vm._v("mdi-chevron-right")]),_c('span',[_vm._v("Selanjutnya")])],1)],1)])],1)]}}])}),_c('ValidationObserver',{directives:[{name:"show",rawName:"v-show",value:(_vm.form === 4),expression:"form === 4"}],ref:"thirdForm",staticClass:"geko-form-wrapper",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_c('v-row',[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Foto & Dokumentasi")])])],1),_c('v-row',[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Foto Dokumen MoU")])]),_c('v-col',{attrs:{"md":"12"}},[_c('geko-input',{attrs:{"item":{
            label: 'Foto Dokumen MoU',
            validation: ['required'],
            type: 'upload',
            api: '/general-lands/upload.php',
            directory: 'mou',
            upload_type: 'image/*',
            setter: 'mou_photo',
            view_data: 'mou_photo',
            option: {
              label_hint:
                'Klik untuk memilih berkas yang akan diunggah',
              max_size: 0.5,
            },
          }},model:{value:(_vm.formData.mou_photo),callback:function ($$v) {_vm.$set(_vm.formData, "mou_photo", $$v)},expression:"formData.mou_photo"}})],1)],1),_c('v-row',[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Foto Dokumentasi Lahan Umum")])]),_c('v-col',{attrs:{"md":"12"}},[_c('geko-input',{attrs:{"item":{
            label: 'Foto Dokumentasi Lahan Umum 1',
            type: 'upload',
            api: '/general-lands/upload.php',
            directory: 'photos',
            upload_type: 'image/*',
            setter: 'photo1',
            view_data: 'photo1',
            option: {
              label_hint:
                'Klik untuk memilih berkas yang akan diunggah',
              max_size: 0.5,
            },
          }},model:{value:(_vm.formData.photo1),callback:function ($$v) {_vm.$set(_vm.formData, "photo1", $$v)},expression:"formData.photo1"}})],1),_c('v-col',{attrs:{"md":"12"}},[_c('geko-input',{attrs:{"item":{
            label: 'Foto Dokumentasi Lahan Umum 2',
            validation: ['required'],
            type: 'upload',
            api: '/general-lands/upload.php',
            directory: 'photos',
            upload_type: 'image/*',
            setter: 'photo2',
            view_data: 'photo2',
            option: {
              label_hint:
                'Klik untuk memilih berkas yang akan diunggah',
              max_size: 0.5,
            },
          }},model:{value:(_vm.formData.photo2),callback:function ($$v) {_vm.$set(_vm.formData, "photo2", $$v)},expression:"formData.photo2"}})],1),_c('v-col',{attrs:{"md":"12"}},[_c('geko-input',{attrs:{"item":{
            label: 'Foto Dokumentasi Lahan Umum 3',
            validation: ['required'],
            type: 'upload',
            api: '/general-lands/upload.php',
            directory: 'photos',
            upload_type: 'image/*',
            setter: 'photo3',
            view_data: 'photo3',
            option: {
              label_hint:
                'Klik untuk memilih berkas yang akan diunggah',
              max_size: 0.5,
            },
          }},model:{value:(_vm.formData.photo3),callback:function ($$v) {_vm.$set(_vm.formData, "photo3", $$v)},expression:"formData.photo3"}})],1)],1),_c('v-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"d-flex flex-row justify-content-end",staticStyle:{"justify-content":"flex-end"}},[_c('v-btn',{staticClass:"mr-3",attrs:{"variant":"light"},on:{"click":function($event){_vm.form--}}},[_vm._v("Kembali")]),_c('v-btn',{attrs:{"type":"submit","variant":"success","disabled":_vm.loading}},[_c('v-icon',[_vm._v("mdi-chevron-right")]),_c('span',[_vm._v("Kirim")])],1)],1)])],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }